import environment from '@/environments/environment.dev'

import HttpClient from '../apiHttpClient'

const apiClient = new HttpClient(environment.adminFAPIUrl)

const ROLE_ENDPOINT = '/v1.0/role'

export const fapiRoleService = {
  async getRolesList() {
    return apiClient.get(`${ROLE_ENDPOINT}/list`)
  },
  async getAssignedRolesByUserId(userId: string) {
    return apiClient.get(`${ROLE_ENDPOINT}/user-roles`, {
      params: { userId },
    })
  },
  async getRoleDetails(roleId: string) {
    return apiClient.get(`${ROLE_ENDPOINT}/${roleId}`)
  },
  async createRole(data) {
    return apiClient.post(ROLE_ENDPOINT, {
      body: data,
    })
  },
  async updateRole(data) {
    return apiClient.put(ROLE_ENDPOINT, {
      body: data,
    })
  },
  async deleteRole(roleId: string) {
    return apiClient.delete(`${ROLE_ENDPOINT}/${roleId}`)
  },
  async getParentRolesList() {
    return apiClient.get(`${ROLE_ENDPOINT}/parents`)
  },
  async getAssignableRolesByUserId(userId: string) {
    return apiClient.get(`${ROLE_ENDPOINT}/assignable/country-role`, {
      params: { userId },
    })
  },
  async assignRolesToUser({ userId, roles }) {
    return apiClient.post(`${ROLE_ENDPOINT}/assign-many`, {
      body: { userId, roles },
    })
  },
  async getUserRoles(userId: string) {
    return apiClient.get(`${ROLE_ENDPOINT}/context/user-roles`, {
      params: { userId },
    })
  },
  async getCurrentUserRoles() {
    return apiClient.get(`${ROLE_ENDPOINT}/context/user-roles`)
  },
}
